import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "result"]
  static values = { url: String, integrationId: String }

  async send(event) {
    event.preventDefault()

    const form = this.element.closest("form")
    const formData = form ? new FormData(form) : new FormData()
    formData.delete("_method")

    if (this.hasIntegrationIdValue && this.integrationIdValue) {
      formData.set("integration[id]", this.integrationIdValue)
    }

    this.buttonTarget.disabled = true
    this.resultTarget.textContent = "Sending…"
    this.resultTarget.className = "text-sm text-fg/50"

    try {
      const csrfMeta = document.querySelector("meta[name='csrf-token']")
      const headers = csrfMeta ? { "X-CSRF-Token": csrfMeta.content } : {}

      const response = await fetch(this.urlValue, {
        method: "POST",
        headers,
        body: formData
      })
      const data = await response.json()

      this.resultTarget.textContent = data.message
      this.resultTarget.className = data.success ? "text-sm text-success" : "text-sm text-danger-text"
    } catch {
      this.resultTarget.textContent = "Request failed"
      this.resultTarget.className = "text-sm text-danger-text"
    } finally {
      this.buttonTarget.disabled = false
    }
  }
}
